import React from 'react';
import { ThemeProvider } from 'styled-components';
import PageLayout from '../components/PageLayout';
import { PurchasePageContent } from '../junto-frontend/components/PurchaseSystem';
import { solRoomTheme } from '../junto-frontend/themes/sol-room';



// PurchasePage is now a simple container that imports the 
// purchase functionality from junto-frontend
const PurchasePage = () => {
  return (
    <ThemeProvider theme={solRoomTheme}>
      <PageLayout
        backButtonText="← Back to Home"
        backButtonLink="/"
        includeFooter={true}
        style={{ overflowX: 'hidden' }}
      >
        <PurchasePageContent />
      </PageLayout>
    </ThemeProvider>
  );
};

export default PurchasePage;